import {
  incidentTourPlanningHref,
  incidentTourWorkspaceHref,
} from './incidentLifecycleTourSteps';

/** The little the tour needs to know about an incident to pick one. */
export type IncidentTourCandidate = {
  id: string;
  archived?: number | boolean | null;
  escalated_at?: string | null;
};

const isLive = (incident: IncidentTourCandidate) => !incident.archived;
const isEscalated = (incident: IncidentTourCandidate) =>
  Boolean(incident.escalated_at);

function pick(
  currentId: string | undefined,
  incidents: IncidentTourCandidate[],
  matches: (incident: IncidentTourCandidate) => boolean
): IncidentTourCandidate | undefined {
  const live = incidents.filter(isLive);
  const current = live.find((incident) => incident.id === currentId);
  if (current && matches(current)) return current;
  return live.find(matches);
}

/**
 * Where the wizard hands off. Initial response only renders for an incident
 * that has not escalated (an escalated one redirects to Planning P and drops
 * the tour flag), so prefer one of those; failing that, jump straight to
 * Planning P on an escalated incident; failing that, there is nothing to walk.
 */
export function resolveIncidentTourWorkspaceHref(
  currentId: string | undefined,
  incidents: IncidentTourCandidate[]
): string | null {
  const initialResponse = pick(
    currentId,
    incidents,
    (incident) => !isEscalated(incident)
  );
  if (initialResponse) return incidentTourWorkspaceHref(initialResponse.id);
  const escalated = pick(currentId, incidents, isEscalated);
  return escalated ? incidentTourPlanningHref(escalated.id) : null;
}

/** Planning P exists only on an escalated incident; the current one if it is. */
export function resolveIncidentTourPlanningHref(
  currentId: string | undefined,
  incidents: IncidentTourCandidate[]
): string | null {
  const escalated = pick(currentId, incidents, isEscalated);
  return escalated ? incidentTourPlanningHref(escalated.id) : null;
}
